import React, {useState} from 'react';
import round from 'lodash/round';
import moment from 'moment';

import useUser from '../../hooks/useUser';
import AppDashboard from '../AppDashboard';
import { useGetSessionsQuery } from '../../redux/services/sessionApi';
import CalendarScreen from '../../components/calendar/CalendarScreen';
import SelectProviderInput from '../../components/providers/SelectProviderInput';

const getStartAndEndDate = ({date, calendarView}) => {
  if (calendarView === 'week') {
    return {
      startDate: moment(date).startOf('week').toISOString(),
      endDate: moment(date).endOf('week').toISOString(),
    };
  }
};

const AdminSchedulingScreen = () => {
  const [date, setDate] = useState(new Date());
  const [calendarView, setCalendarView] = useState('week');
  const [providerId, setProviderId] = useState(null);
  const user = useUser();
  const {startDate, endDate} = getStartAndEndDate({date, calendarView});
  const childProps = {
    loading: !user,
  };
  const query = {
    provider_id: providerId,
    start_time: startDate, 
    end_time: endDate,
    limit: 100,
  };
  const sessionQuery = useGetSessionsQuery(query, {skip: !providerId});
  const sessions = sessionQuery?.data?.data || [];
  const metrics = !sessions || !sessions.length ? [] : [
    {
      label: 'Total Sessions', 
      value: sessions.length
    },
    {
      label: 'Total Care Hours', 
      value: round(sessions.reduce((acc, s) => acc + s.duration, 0) / 60, 1),
    },
  ];
  return (
    <AppDashboard 
      loading={childProps.loading} 
      error={childProps.error} 
    >
      {
        <SelectProviderInput
          onChange={e => setProviderId(e.target.value)}
        />
      }
      {
        !!providerId &&
        <CalendarScreen
          providerId={providerId}
          calendarView={calendarView}
          date={date}
          sessions={sessions}
          metrics={metrics}
          onDateChange={(e, date) => setDate(date)}
          onCalendarViewChange={(e, view) => setCalendarView(view)}
        />
      }
    </AppDashboard>
  );
};

export default AdminSchedulingScreen;